export default __webpack_public_path__ + "static/media/SCGC_Logo_Color.d3deb0e0.png";